(ns ycweb.components.svg-icons
  (:require
    [rum.core :as rum]
    [ycweb.components.common :as cmn]
    [ycweb.util.core :as u]))

(rum/defc svg-icon-yuppiechef-logo < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 196 24",
    :aria-hidden (or aria-hidden "true")}
   [:path
    {:d "M18.57,1.83c-.74,0-1.26,.43-1.69,1.06l-5.66,8.06L5.66,2.91c-.43-.63-.94-1.06-1.71-1.06-1,0-1.77,.74-1.77,1.69,0,.49,.17,.89,.4,1.23l6.89,9.46v6.17c0,.97,.77,1.74,1.74,1.74s1.77-.77,1.77-1.74v-6.26l6.83-9.34c.26-.34,.49-.77,.49-1.26,0-.94-.69-1.71-1.71-1.71Z"}]
   [:path
    {:d "M39.34,1.86c-1,0-1.77,.77-1.77,1.74V13.51c0,3.69-1.91,5.54-5.03,5.54s-5.06-1.97-5.06-5.69V3.6c0-.97-.77-1.74-1.74-1.74s-1.77,.77-1.77,1.74V13.51c0,5.8,3.31,8.8,8.51,8.8s8.6-3,8.6-8.97V3.6c0-.97-.77-1.74-1.74-1.74Z"}]
   [:path
    {:d "M54.37,2h-6.11c-1,0-1.77,.77-1.77,1.77V20.4c0,.97,.77,1.74,1.77,1.74s1.74-.77,1.74-1.74v-4.83h3.97c4.4,0,8-2.34,8-6.83v-.06c0-4.03-2.91-6.69-7.6-6.69Zm4.03,6.83c0,2.09-1.66,3.57-4.31,3.57h-4.09V5.2h4.09c2.63,0,4.31,1.23,4.31,3.57v.06Z"}]
   [:path
    {:d "M74.03,2h-6.11c-1,0-1.77,.77-1.77,1.77V20.4c0,.97,.77,1.74,1.77,1.74s1.74-.77,1.74-1.74v-4.83h3.97c4.4,0,8-2.34,8-6.83v-.06c0-4.03-2.91-6.69-7.6-6.69Zm4.03,6.83c0,2.09-1.66,3.57-4.31,3.57h-4.09V5.2h4.09c2.63,0,4.31,1.23,4.31,3.57v.06Z"}]
   [:path
    {:d "M108.97,18.86h-10.03v-5.37h8.6c.86,0,1.57-.69,1.57-1.54s-.71-1.6-1.57-1.6h-8.6V5.14h9.89c.86,0,1.57-.69,1.57-1.57s-.71-1.57-1.57-1.57h-11.63c-1,0-1.77,.77-1.77,1.77V20.23c0,1,.77,1.77,1.77,1.77h11.77c.86,0,1.57-.69,1.57-1.57s-.71-1.57-1.57-1.57Z"}]
   [:path
    {:d "M130.6,16.77c-.43,0-.8,.17-1.06,.4-1.46,1.23-2.89,1.91-5,1.91-3.83,0-6.6-3.17-6.6-7.09v-.06c0-3.91,2.8-7.06,6.6-7.06,1.91,0,3.4,.69,4.77,1.8,.23,.17,.57,.34,1.06,.34,.97,0,1.74-.74,1.74-1.71,0-.63-.31-1.11-.69-1.4-1.74-1.34-3.77-2.26-6.86-2.26-6.06,0-10.31,4.66-10.31,10.34v.06c0,5.74,4.34,10.29,10.17,10.29,3.23,0,5.37-1.03,7.26-2.69,.31-.29,.57-.71,.57-1.26,0-.89-.77-1.63-1.66-1.63Z"}]
   [:path
    {:d "M151.6,1.86c-.97,0-1.74,.77-1.74,1.74v6.71h-9.54V3.6c0-.97-.77-1.74-1.74-1.74s-1.77,.77-1.77,1.74V20.4c0,.97,.77,1.74,1.77,1.74s1.74-.77,1.74-1.74v-6.83h9.54v6.83c0,.97,.77,1.74,1.74,1.74s1.77-.77,1.77-1.74V3.6c0-.97-.77-1.74-1.77-1.74Z"}]
   [:path
    {:d "M172.63,18.86h-10.03v-5.37h8.6c.86,0,1.57-.69,1.57-1.54s-.71-1.6-1.57-1.6h-8.6V5.14h9.89c.86,0,1.57-.69,1.57-1.57s-.71-1.57-1.57-1.57h-11.63c-1,0-1.77,.77-1.77,1.77V20.23c0,1,.77,1.77,1.77,1.77h11.77c.86,0,1.57-.69,1.57-1.57s-.71-1.57-1.57-1.57Z"}]
   [:path
    {:d "M192.23,5.2c.89,0,1.6-.71,1.6-1.6s-.71-1.6-1.6-1.6h-11.66c-1,0-1.77,.77-1.77,1.77V20.4c0,.97,.77,1.74,1.77,1.74s1.74-.77,1.74-1.74v-6.54h8.63c.89,0,1.6-.71,1.6-1.6s-.71-1.6-1.6-1.6h-8.63V5.2h9.91Z"}]
   [:path
    {:d "M87.77,1.86c-1,0-1.77,.77-1.77,1.74V20.4c0,.97,.77,1.74,1.77,1.74s1.74-.77,1.74-1.74V3.6c0-.97-.77-1.74-1.74-1.74Z"}]])

(rum/defc svg-icon-visa < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Visa"]
   [:path.svg-icon__base
    {:d
     "M21,4l-6.9,16h-4.5L6.21,7.23c-.21-.79-.39-1.07-1.01-1.41-1.02-.54-2.71-1.05-4.2-1.36l.1-.46h7.24c.92,0,1.75,.6,1.96,1.63l1.79,9.26,4.43-10.89h4.47Z"}]])

(rum/defc svg-icon-mastercard < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Mastercard"]
   [:path.svg-icon__base
    {:d
     "M9,12c0,2.45,1.18,4.62,3,5.99,1.82-1.37,3-3.54,3-5.99s-1.18-4.62-3-5.99c-1.82,1.37-3,3.54-3,5.99Z"}]
   [:path.svg-icon__base
    {:d
     "M8,12c0-2.65,1.21-5.01,3.11-6.57-1.07-.59-2.3-.93-3.61-.93C3.36,4.5,0,7.86,0,12s3.36,7.5,7.5,7.5c1.31,0,2.54-.34,3.61-.93-1.9-1.56-3.11-3.92-3.11-6.57Z"}]
   [:path.svg-icon__base
    {:d
     "M16.5,4.5c-1.31,0-2.54,.34-3.61,.93,1.9,1.56,3.11,3.92,3.11,6.57s-1.21,5.01-3.11,6.57c1.07,.59,2.3,.93,3.61,.93,4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5Z"}]])

(rum/defc svg-icon-dinersclub < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Diner's Club"]
   [:circle.svg-icon__accent {:cx "10.54", :cy "11.98", :r "9.5"}]
   [:path.svg-icon__base
    {:d
     "M10.52,22c-5.53,.03-10.09-4.46-10.09-9.91C.43,6.12,4.98,2,10.52,2h2.59c5.47,0,10.46,4.12,10.46,10.09,0,5.45-4.99,9.91-10.46,9.91h-2.59Zm.02-19.17c-5.06,0-9.15,4.1-9.15,9.16,0,5.06,4.1,9.15,9.15,9.15,5.06,0,9.15-4.1,9.16-9.15,0-5.06-4.1-9.15-9.16-9.16Zm-2.08,14.57V6.57c-2.18,.84-3.72,2.94-3.72,5.42,0,2.47,1.55,4.58,3.72,5.41Zm7.88-5.41c0-2.47-1.55-4.58-3.73-5.42v10.83c2.18-.84,3.72-2.94,3.73-5.42Z"}]])

(rum/defc svg-icon-amex < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "American Express"]
   [:polygon.svg-icon__base {:points "2 2 22 2 22 22 2 22 2 2 2 2"}]
   [:polygon.svg-icon__accent
    {:points
     "22 18.09 22 16.9 20.48 15.26 22 13.63 22 12.44 19.35 15.28 22 18.09"}]
   [:polygon.svg-icon__accent
    {:points "10.25 9.13 11.79 9.13 11.02 7.29 10.25 9.13"}]
   [:path.svg-icon__accent
    {:d
     "M22,11.59V5h-3l-.68,1.9-.68-1.9h-3.92v2.53l-1.12-2.53h-3.18l-3.26,7.41h2.65v6.57l8.17,.02,1.28-1.43,1.29,1.43h2.43v-.82h-2.03l-1.69-1.85-1.67,1.85h-2.04s-4.88,0-4.88,0v-5.78h4.9s2.07,0,2.07,0l1.66,1.83,1.66-1.83h2.01v-.8h0Zm-9.18,0l-.48-1.16h-2.62l-.48,1.16h-1.76l2.56-5.78h2.03l2.55,5.78h-1.8Z"}]
   [:polygon.svg-icon__accent
    {:points
     "11.28 15.94 11.28 16.82 14.6 16.82 14.6 18.14 17.28 15.28 14.6 12.42 14.6 13.72 11.28 13.72 11.28 14.63 14.52 14.63 14.52 15.94 11.28 15.94"}]
   [:polygon.svg-icon__base
    {:points
     "14.59 11.58 14.59 5.8 17.07 5.81 18.34 9.36 19.62 5.8 22 5.8 22 11.58 20.47 11.59 20.47 7.63 19.02 11.58 17.63 11.58 16.15 7.61 16.15 11.58 14.59 11.58 14.59 11.58"}]])

(rum/defc svg-icon-discovery < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Discovery Miles"]
   [:path.svg-icon__base
    {:d
     "M18.69,4.5c-1.66-1.67-4.09-2.5-7.28-2.5H6v6.81H2v2h4v2.37H2v2h4v6.81h4.79c3.41,0,6-.86,7.76-2.58,1.76-1.72,2.64-4.26,2.64-7.61s-.83-5.64-2.5-7.31Zm-1.54,13.49c-1.37,1.33-3.5,2.01-6.36,2.01h-2.79v-4.81h4v-2h-4v-2.37h4v-2h-4V4h3.4c2.63,0,4.6,.64,5.87,1.92,1.27,1.27,1.91,3.26,1.91,5.89,0,2.78-.69,4.86-2.04,6.18Z"}]])

(rum/defc svg-icon-ebucks < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "eBucks"]
   [:path.svg-icon__base
    {:d
     "M22,12c0,5.52-4.48,10-10,10S2,17.52,2,12C2,6.48,6.48,2,12,2s10,4.48,10,10"}]
   [:path.svg-icon__accent
    {:d
     "M16.41,11.33c.74-.22,1.23-.92,1.23-1.78v-.22c0-1.25-.88-2.09-2.49-2.09h-2.26s-.02,0-.02,0c-.18-.01-.35,.05-.49,.18-.13,.13-.19,.3-.18,.47,0,.01,0,.02,0,.02v7.66s0,0,0,0c0,.04,.01,.08,.04,.11,.03,.03,.07,.04,.1,.04,0,0,0,0,0,0h2.86c1.73,0,2.67-.96,2.67-2.27v-.2c0-1.05-.63-1.77-1.46-1.94m-2.84-2.9h1.18c1.03,0,1.53,.35,1.53,1.12v.15c0,.71-.49,1.12-1.42,1.12h-1.3v-2.4Zm1.29,6.08h-1.29v-2.58h1.45c.92,0,1.46,.39,1.47,1.28,0,1.02-.56,1.31-1.63,1.31"}]
   [:path.svg-icon__accent
    {:d
     "M8.71,9.28c-1.52,0-2.57,.95-2.57,2.54v1.55c0,1.52,.89,2.49,2.61,2.49,1.09,0,1.92-.42,2.36-1.25,.02-.03,.09-.18,.09-.18,0,0,0,0,0,0,.02-.05,.01-.11-.03-.15-.01-.01-.03-.02-.04-.03h0s0,0,0,0c0,0,0,0,0,0l-.71-.35c-.1-.04-.22-.02-.31,.06-.02,.02-.03,.04-.04,.06-.2,.4-.6,.75-1.32,.75-.92,0-1.29-.55-1.29-1.37v-.35h3.21c.15,0,.3-.07,.42-.18,.13-.13,.19-.31,.19-.48h0v-.41c0-1.86-.97-2.69-2.56-2.69m1.28,2.65h-2.53v-.15c0-.78,.37-1.4,1.25-1.4,.96,0,1.28,.64,1.28,1.33v.22Z"}]
   [:path.svg-icon__base
    {:d
     "M22.5,5c.83,0,1.5-.67,1.5-1.5,0-.83-.67-1.5-1.5-1.5-.83,0-1.5,.67-1.5,1.5,0,.83,.67,1.5,1.5,1.5"}]])

(rum/defc svg-icon-snapscan < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "SnapScan"]
   [:path.svg-icon__base
    {:d
     "M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10,10-4.48,10-10S17.52,2,12,2Zm0,19c-4.97,0-9-4.03-9-9S7.03,3,12,3s9,4.03,9,9-4.03,9-9,9Z"}]
   [:rect.svg-icon__base
    {:x "12.64", :y "7.36", :width "4", :height "4", :rx "1", :ry "1"}]
   [:rect.svg-icon__base
    {:x "7.36", :y "7.36", :width "4", :height "4", :rx "1", :ry "1"}]
   [:rect.svg-icon__base
    {:x "7.36", :y "12.64", :width "4", :height "4", :rx "1", :ry "1"}]
   [:rect.svg-icon__base
    {:x "12.64", :y "12.64", :width "4", :height "4", :rx "1", :ry "1"}]])

(rum/defc svg-icon-zapper < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
    {:class icon-class
     :xmlns "http://www.w3.org/2000/svg",
     :viewBox "0 0 24 24",
     :aria-hidden (or aria-hidden "true")}
    [:title "Zapper"]
    [:rect.svg-icon__base
     {:x "2", :y "2", :width "20", :height "20", :rx "2", :ry "2"}]
    [:path.svg-icon__accent
     {:d
      "M13.88,6h-5.82c-.88,0-1.59,.72-1.59,1.6s.71,1.6,1.6,1.6c.01,0,.02,0,.03,0h2.93l2.86-3.19Z"}]
    [:path.svg-icon__accent
     {:d
      "M14.95,6.46L6.65,15.48c-.19,.26-.31,.58-.31,.93,0,.88,.71,1.59,1.59,1.59h7.92c.88,0,1.59-.71,1.59-1.59s-.71-1.59-1.59-1.59h-4.11s-.31-.06-.03-.34l5.44-5.73s.04-.04,.06-.06l.09-.11c.21-.27,.34-.6,.34-.97,0-.88-.71-1.59-1.59-1.59-.43,0-.82,.17-1.11,.45"}]])

(rum/defc svg-icon-mobicred < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Mobicred"]
   [:polygon.svg-icon__base {:points "2 2 22 2 22 22 2 22 2 2 2 2"}]
   [:path.svg-icon__accent
    {:d
     "M5.98,10.61c-.12,0-.24-.03-.34-.1-.29-.19-.38-.58-.19-.87,.88-1.36,2.21-2.26,3.76-2.55,1.55-.28,3.13,.09,4.43,1.06,.28,.21,.34,.6,.13,.88-.21,.28-.6,.34-.88,.13-1.02-.76-2.25-1.06-3.46-.83-1.2,.22-2.24,.93-2.93,1.99-.12,.19-.32,.29-.53,.29"}]
   [:path.svg-icon__accent
    {:d
     "M4.63,8.96c-.12,0-.23-.03-.34-.1-.29-.19-.37-.58-.19-.87,1.1-1.7,2.76-2.82,4.69-3.18,1.94-.36,3.9,.12,5.53,1.33,.28,.21,.34,.6,.13,.88-.21,.28-.6,.34-.88,.13-1.35-1-2.96-1.39-4.56-1.1-1.58,.29-2.95,1.22-3.86,2.62-.12,.19-.32,.29-.53,.29"}]
   [:path.svg-icon__accent
    {:d
     "M18.82,10.42c-.32-.28-.65-.49-1-.66-.08-.03-.17-.07-.27-.12-.03-.01-.06-.02-.09-.03-.41-.13-.81-.2-1.21-.2-.51,0-1,.1-1.45,.29-.02,0-.03,.01-.05,.02-.06,.03-.12,.05-.17,.08-.06,.03-.12,.06-.18,.09-.02,.01-.04,.02-.05,.03-.15,.09-.3,.19-.44,.3-.11,.11-.21,.2-.3,.26-.11,.09-.2,.13-.27,.13h-.04c-.07,0-.16-.04-.27-.13-.09-.06-.19-.15-.3-.26-.14-.11-.29-.21-.44-.3-.02-.01-.04-.02-.06-.03-.06-.03-.12-.06-.18-.09-.06-.03-.12-.06-.18-.08-.02,0-.03-.01-.05-.02-.46-.19-.94-.28-1.45-.29-.4,0-.8,.07-1.21,.2-.03,0-.06,.02-.09,.03-.1,.05-.2,.09-.27,.12-.34,.16-.68,.38-1,.66-.41,.43-.66,.76-.76,1-.28,.57-.42,1.05-.42,1.43v5.18c0,.23,.03,.41,.1,.54,.06,.1,.13,.17,.21,.24,.06,.04,.13,.09,.2,.12,.06,.03,.15,.05,.28,.07,0,0,.01,0,.02,0,0,0,0,0,.01,0,.11,0,.22-.03,.32-.07,.03-.01,.05-.02,.07-.04,.13-.08,.24-.21,.34-.38,.05-.12,.08-.28,.08-.47v-5.19c.02-.27,.14-.56,.34-.86t0,0s.06-.09,.09-.13c.26-.32,.57-.55,.91-.68,.01,0,.03-.01,.04-.02,.05-.02,.11-.04,.17-.05,.03,0,.05-.02,.08-.02,.04,0,.09-.02,.13-.02,.04,0,.08-.01,.12-.02,.05,0,.1,0,.15,0,.03,0,.06,0,.09,0h0c.08,0,.16,0,.24,.01,.02,0,.04,0,.07,.01,.05,0,.11,.02,.16,.03,.07,.01,.13,.03,.19,.05,0,0,0,0,.02,0,.4,.13,.75,.39,1.06,.76,.25,.39,.38,.7,.38,.92v5.22c0,.21,.04,.38,.1,.52,.06,.11,.13,.2,.22,.27,.05,.04,.11,.08,.17,.1,.06,.03,.16,.05,.3,.07,0,0,.02,0,.02,0,0,0,.02,0,.02,0,.14-.02,.24-.04,.3-.07,.06-.03,.12-.06,.17-.1,.08-.07,.15-.16,.21-.27,.07-.14,.1-.32,.1-.52v-5.22c0-.22,.13-.53,.38-.92,.31-.38,.66-.63,1.06-.76,0,0,.01,0,.02,0,.06-.02,.13-.04,.19-.05,.05-.01,.11-.02,.16-.03,.02,0,.04,0,.07-.01,.08,0,.16-.01,.24-.01h0s.06,0,.09,0c.05,0,.11,0,.16,0,.04,0,.08,.01,.12,.02,.05,0,.09,.01,.13,.02,.03,0,.05,.02,.08,.02,.06,.01,.11,.03,.17,.05,.01,0,.03,.01,.04,.02,.34,.13,.65,.36,.91,.68,.03,.04,.06,.09,.09,.13,0,0,0,0,0,0,.21,.3,.32,.59,.34,.86v5.19c0,.2,.03,.35,.08,.47,.09,.17,.2,.3,.34,.38,.02,.01,.05,.02,.07,.04,.1,.04,.2,.07,.31,.07,0,0,0,0,.01,0,0,0,.01,0,.02,0,.13-.01,.23-.03,.28-.07,.08-.04,.14-.08,.2-.12,.07-.06,.14-.14,.21-.24,.06-.13,.1-.31,.1-.54v-5.18c0-.39-.14-.86-.42-1.43-.09-.23-.35-.56-.76-1"}]])

(rum/defc svg-icon-payflex < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "Payflex"]
   [:rect.svg-icon__base
    {:x "2", :y "2", :width "20", :height "20", :rx "2", :ry "2"}]
   [:path.svg-icon__accent-shade
    {:d
     "M13.83,10.17c-.25,1.21-.25,2.46,0,3.67,1.73.35,3.37,1.19,4.72,2.53-1.2-1.2-1.81-2.78-1.81-4.37s.6-3.16,1.81-4.37c-1.33,1.33-2.99,2.18-4.72,2.53M10.17,10.17c1.21.24,2.46.24,3.67,0,.34-1.73,1.19-3.38,2.54-4.71-1.2,1.2-2.78,1.8-4.36,1.8s-3.16-.6-4.36-1.8c1.32,1.33,2.17,2.98,2.51,4.71M13.83,13.84c-1.21-.24-2.46-.24-3.67,0-.34,1.73-1.19,3.38-2.54,4.71,1.2-1.2,2.78-1.8,4.36-1.8s3.16.61,4.36,1.8c-1.32-1.34-2.16-2.98-2.51-4.71M10.16,13.84c.25-1.21.25-2.46,0-3.67-1.73-.35-3.37-1.19-4.72-2.53,1.21,1.2,1.82,2.78,1.82,4.37s-.6,3.16-1.81,4.37c1.34-1.34,2.99-2.19,4.71-2.53"}]
   [:path.svg-icon__accent
    {:d
     "M5.45,5.45c-.6.61-.6,1.56,0,2.18,1.34,1.34,2.99,2.18,4.72,2.53-.35-1.77-1.23-3.4-2.54-4.71-.56-.57-1.5-.61-2.1-.08-.03.03-.06.05-.08.08M5.45,18.55c.56.57,1.5.61,2.1.08.03-.03.06-.05.08-.08,1.31-1.3,2.19-2.94,2.54-4.71-1.73.35-3.37,1.19-4.72,2.53-.6.61-.6,1.56,0,2.18M18.55,18.55c-.56.57-1.5.61-2.1.08-.03-.03-.06-.05-.08-.08-1.34-1.34-2.18-2.98-2.54-4.71,1.73.35,3.37,1.19,4.72,2.53.6.61.6,1.56,0,2.18M18.55,5.45c.6.61.6,1.56,0,2.18-1.34,1.34-2.99,2.18-4.72,2.53.34-1.73,1.19-3.38,2.54-4.71.56-.57,1.5-.61,2.1-.08.03.03.06.05.08.08"}]])

(rum/defc svg-icon-eft < rum/reactive
  [{:keys [icon-class aria-hidden]
    :as options}]
  [:svg.svg-icon
   {:class icon-class
    :xmlns "http://www.w3.org/2000/svg",
    :viewBox "0 0 24 24",
    :aria-hidden (or aria-hidden "true")}
   [:title "EFT"]
   [:path.svg-icon__base
    {:d
     "M8.5,11.76h-3.56l-.46,2.42h3.99l-.34,1.82H2L3.9,6h5.92l-.36,1.82h-3.77l-.42,2.14h3.56l-.34,1.8Z"}]
   [:path.svg-icon__base
    {:d
     "M11.27,6h5.86l-.36,1.82h-3.71l-.46,2.34h3.49l-.36,1.81h-3.47l-.76,4.02h-2.14l1.9-10Z"}]
   [:path.svg-icon__base
    {:d
     "M24,7.87v-1.87h-6.27l-.37,1.87h2.64l-1.53,8.12c-5.98,.28-10.75,1.87-14.24,3.13l-.02,.24c4.94-1.54,11.55-2.78,19.79-1.14v-2.11c-1.16-.11-2.29-.16-3.38-.17l1.52-8.08h1.86Z"}]])